<ng-container *ngIf="storyEditMode">
  <li class="newMetaData">
    <ng-container *ngIf="newMeta.fieldType === 'toggle'">
      <label>{{ newMeta.fieldName | titlecase }}</label>
      <div class="dataField">
        <label class="switch" tabindex="0">
          <input 
            type="checkbox"
            (click)="toggleSwitch(textResult.value)"
            [disabled]="!storyEditMode"
            [(ngModel)]="textResult.value"
            [checked]="textResult.value"
           
          />
          <span class="slider round"  [hidden]="disabledToggle"></span>
        </label>
      </div>
    </ng-container>
    <ng-container *ngIf="newMeta.fieldType === 'text'">
      <ng-container
        *ngIf="newMeta.toggleToField == 'true' || newMeta.toggleToField">
        <label>{{ newMeta.fieldName | titlecase }}</label>
        <div class="dataField">
          <label class="switch" tabindex="0">
            <input
              type="checkbox"
              (change)="toggleToFieldChange()"
              [disabled]="!storyEditMode"
              [checked]="toggleToField"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </ng-container>
      <div *ngIf="toggleToField" style="float: left; width: 100%;">
        <label>{{ newMeta.fieldName | titlecase }}</label>
        <div class="dataField">
          <label tabindex="1">
            <input
              type="text"
              [formControl]="textResultForm"
              [disabled]="!storyEditMode"
              [(ngModel)]="textResult.value"
            />
          </label>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="newMeta.fieldType === 'textArea'">
    <li>
      <label>{{ newMeta.fieldName| titlecase }}</label>
      <div class="dataField" #textAreaEl>
        <ng-container>
        <ckeditor #editorDynamicField [(ngModel)]="textResult.value" class="seoInputBox" [editor]="ckEditor"
        [config]="ckconfig" [tabindex]="0" (ready)="ckchanges($event, 'ready', 'desc')"
          (change)="ckchanges($event, 'change', 'desc')"
          (blur)="ckchanges($event, 'blur', 'desc')"
          (focus)="ckchanges($event, 'focus', 'desc')" (error)="ckchanges($event, 'error', 'desc')"></ckeditor>
        </ng-container>
      </div>
    </li>
    </ng-container>
  </li>
</ng-container>